import { render, staticRenderFns } from "./VehicleTypeChipLabel.vue?vue&type=template&id=330f01c6&scoped=true&lang=pug"
import script from "./VehicleTypeChipLabel.vue?vue&type=script&lang=js"
export * from "./VehicleTypeChipLabel.vue?vue&type=script&lang=js"
import style0 from "./VehicleTypeChipLabel.vue?vue&type=style&index=0&id=330f01c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330f01c6",
  null
  
)

export default component.exports